import { jsxs as i, jsx as r } from "react/jsx-runtime";
const o = { right: 0, down: 90, left: 180, up: 270 }, s = ({
  direction: t = "right",
  ...e
}) => /* @__PURE__ */ i(
  "svg",
  {
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: "24",
    style: {
      overflow: "visible",
      transform: `rotate(${o[t]}deg)`
    },
    viewBox: "0 0 24 24",
    width: "24",
    ...e,
    children: [
      /* @__PURE__ */ r(
        "path",
        {
          d: "M4 12h15.5",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2",
          stroke: "currentColor",
          style: {
            transition: "var(--builders-transition-duration)",
            transformOrigin: "center",
            translate: "var(--builders-icon--hover, calc(var(--builders-unit-05) + 5%)",
            scale: "var(--builders-icon--hover, 70% 100%)"
          }
        }
      ),
      /* @__PURE__ */ r(
        "path",
        {
          d: "M19.5 12m0 0-7-7m7 7-7 7",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "2",
          stroke: "currentColor",
          style: {
            transition: "var(--builders-transition-duration)",
            translate: "var(--builders-icon--hover, var(--builders-unit-05))"
          }
        }
      )
    ]
  }
);
export {
  s as AnimatedArrow
};
//# sourceMappingURL=animated-arrow.js.map
